"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _types = require('web/screens/Signup/types');

// An error a sign-up step shows inline, next to the field or action it is
// about. `step` is where it belongs; the flow returns there to show it.








 const GENERIC_SETUP_ERROR = "We couldn't finish setting up your account. Please try again."; exports.GENERIC_SETUP_ERROR = GENERIC_SETUP_ERROR
 const LOGIN_AFTER_SETUP_ERROR = "Your account is ready, but we couldn't sign you in. Log in to continue, or contact support@bloomtext.com."; exports.LOGIN_AFTER_SETUP_ERROR = LOGIN_AFTER_SETUP_ERROR
// A phone invitee's setup whose response was lost, so it can't name the
// account it made. Signing in with the phone could pick another account on the
// number. Signing in with an unverified email sends a link to verify it.
 const PHONE_SETUP_LOGIN_ERROR = "Your account is ready, but we couldn't sign you in automatically. Sign in with the email you entered (we'll send a link to verify it first), or contact support@bloomtext.com."; exports.PHONE_SETUP_LOGIN_ERROR = PHONE_SETUP_LOGIN_ERROR
 const PHONE_REQUIRED_ERROR = 'Enter a mobile phone number.'; exports.PHONE_REQUIRED_ERROR = PHONE_REQUIRED_ERROR
 const AGREEMENTS_REQUIRED_ERROR = 'Review and accept the agreements to continue.'; exports.AGREEMENTS_REQUIRED_ERROR = AGREEMENTS_REQUIRED_ERROR

// The final submit's client errors (client.submitSetup, see hooks/useSubmit),
// each with the step it sends the person back to.
 const submitErrors = {
  'weak password': {
    step: _types.SetupSteps.PASSWORD,
    message: "That password isn't strong enough. Use 12 or more characters with mixed case and a symbol.",
  },
  'invalid phone number': {
    step: _types.SetupSteps.PERSONAL_INFO,
    message: "We can't text this number. Use a mobile number in a supported country.",
  },
  'unsupported region': {
    step: _types.SetupSteps.PERSONAL_INFO,
    message: "We can't text this number. Use a mobile number in a supported country.",
  },
  'Agreement acceptance is required': {
    step: _types.SetupSteps.LEGAL_AGREEMENTS,
    message: exports.AGREEMENTS_REQUIRED_ERROR,
  },
  'organization matches changed': {
    step: _types.SetupSteps.ORG_INFO,
    message: 'Your organization invitations changed. Review them and continue.',
  },
}; exports.submitErrors = submitErrors
